export default 'career-platform-front';
